<template>

  <section id="termo-uso" class="d-flex align-items-center termo-uso">

      <div class="container">

        <div class="row">

          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">

            <div class="d-flex justify-content-start flex-fill mb-4" data-aos="fade-right" data-aos-delay="150">
              <a href="/">
                <img src="../assets/img/logo.png" alt="" class="img-fluid" style="width: 180px; margin-left: -7px;">
              </a>
            </div>

            <div class="col-lg-12 d-flex flex-column justify-content-center mb-4">

              <h3 class="pb-2 text-center" data-aos="fade-up">TERMOS DE USO</h3>
              <br>
              <p>
                Estes termos e condições gerais de uso aplicam-se aos serviços
                prestados pela pessoa jurídica SIGAME DIGITAL NFE LTDA,
                devidamente registrada sob o CNPJ 52.366.728/0001-35, com sede na
                Av Maringá, nº 5046, Sala 013, Zona II, Umuarama-PR,
                doravante denominada CONTRATADA, para o uso do sistema web denominado
                SIGAME, disponibilizado por meio do endereço eletrônico
                “www.sigame.digital”, e a PESSOA JURÍDICA identificada no cadastro do
                banco de dados do SIGAME, doravante denominado simplesmente
                CONTRATANTE, que celebram o presente contrato de prestação de serviço,
                regido pelas cláusulas e condições abaixo.
              </p>
              <br>
              <p>
                <strong>Cláusula 1ª – OBJETO DO CONTRATO</strong>
              </p>
              <p>
                1.1&nbsp;- Este contrato tem como objeto o direito de uso em caráter não
                exclusivo e intransferível do SISTEMA SIGAME de propriedade, operação e
                responsabilidade&nbsp;da CONTRATADA, disponibilizado para utilização via
                internet, por meio do site “www.sigame.digital”.
              </p>
              <p>
                1.2&nbsp;- O SISTEMA SIGAME é um emissor automatizado de notas fiscais,
                focado no mercado digital. É ele integrado com as principais
                plataformas de pagamento, visando a automatização do processo de
                emissão das notas fiscais.
              </p>
              <p>
                1.3 – A CONTRATADA não se propõe a realizar NENHUM tipo de
                consultorias tributárias e/ou financeiras para a CONTRATADA.
              </p>
              <br>
              <p>
                <strong>
                  Cláusula 2ª - DA ACEITAÇÃO DOS TERMOS E CONDIÇÕES GERAIS
                </strong>
              </p>
              <p>
                2.2&nbsp;- Ao realizar qualquer ação diretamente no sistema SIGAME ou por
                meio das APIs disponíveis para integração com softwares de terceiros,
                a CONTRATANTE aceita integralmente as presentes normas e compromete-se
                a observá-las, considerando-se, para todo efeito, a efetivação da
                contratação do serviço objeto deste contrato.
              </p>
              <p>
                2.2 - A CONTRATADA tem o direito de revisar os Termo de Uso a qualquer
                momento, sendo que, o uso continuado do serviço por parte da
                CONTRATANTE será considerado como aceitação irrevogável de tais
                revisões. O CONTRATANTE poderá consultar a versão atual dos Termos de
                Uso a qualquer momento pelo endereço:
                <a href="https://sigame.digital/termos-de-uso">
                  https://sigame.digital/termos-de-uso
                </a>
              </p>
              <p>
                2.3&nbsp;- Caso não concorde com quaisquer das regras aqui descritas, a
                CONTRATANTE deve, imediatamente, abster-se de contratar o serviço.
              </p>
              <br>
              <p>
                <strong>Cláusula 3ª – LICENÇA DO SOFTWARE</strong>
              </p>
              <p>
                3.1&nbsp;- CONCESSÃO DA LICENÇA – Art. 2º §5º Lei n° 9.609/98 - A Este
                contrato concede a CONTRATANTE uma licença revogável, não exclusiva e
                intransferível para USO do SISTEMA SIGAME.
              </p>
              <p>
                3.2 - Em nenhuma hipótese a CONTRATANTE terá acesso ao código fonte do
                SISTEMA SIGAME ora licenciado, por este se tratar de propriedade
                intelectual da CONTRATADA.
              </p>
              <br>
              <p>
                <strong>Cláusula 4ª – COPYRIGHT</strong>
              </p>
              <p>
                4.1&nbsp;- Todos os títulos e direitos autorais relativos ao SOFTWARE
                (incluindo quaisquer imagens, fotografias, animações, vídeos, áudios,
                músicas e textos incorporados ao SOFTWARE), os materiais impressos que
                o acompanham, e quaisquer cópias do SOFTWARE são de propriedade da
                CONTRATADA ou seus fornecedores. O SOFTWARE é protegido pela lei nº
                9.609/98. Assim, o CONTRANTE deverá tratar o SOFTWARE como qualquer
                outro material protegido por direito autoral. É vedada a reprodução
                dos materiais impressos que acompanham o SOFTWARE.
              </p>
              <br>
              <p>
                <strong>Cláusula 5ª – LIMITAÇÃO DE RESPONSABILIDADE</strong>
              </p>
              <p>
                5.1. A CONTRATADA não responderá, em nenhuma hipótese, ainda que em
                caráter solidário ou subsidiário:
              </p>
              <p>
                (a) Pelos serviços ou produtos oferecidos no site, no que diz respeito
                a sua disponibilidade, qualidade, quantidade, características
                essenciais, ofertas, preços, formas de pagamento ou quaisquer outros
                elementos a eles referentes;
              </p>
              <p>
                (b) Por eventuais prejuízos sofridos pela CONTRATANTE em razão da
                tomada de decisões com base nas informações disponibilizadas no
                sistema;
              </p>
              <p>
                (c) Por eventuais prejuízos sofridos pela CONTRATANTE em razão de
                falhas no sistema de informática ou nos servidores que independam de
                culpa da CONTRATADA ou em sua conectividade com a internet de modo
                geral, devendo a CONTRATANTE manter, as suas expensas, acesso a
                internet e qualquer recurso necessários para acesso e comunicação com
                o SISTEMA SIGAME;
              </p>
              <p>
                (d) Por situações de caso fortuito ou força maior, nos termos do
                artigo 393 do Código Civil Brasileiro;
              </p>
              <p>
                (e) Por danos causados por programas nocivos ao SOFTWARE, tais como,
                mas sem se limitar a vírus, trojans e hackers ;
              </p>
              <p>
                (f) Por quaisquer ações efetuadas por Usuários que não tenham poderes
                para atuar em nome da CONTRATANTE.
              </p>
              <p>
                (h) Pela autenticidade e veracidade das informações contidas nos
                documentos fiscais eletrônicos.
              </p>
              <p>
                (i) Pela falha nos sistemas da secretaria da fazenda, receita federal
                ou das prefeituras de emissão, cancelamento, consulta download e
                manifestação do destinatário e todas as outras ações disponibilizadas
                no SISTEMA SIGAME.
              </p>
              <p>
                5.2. A CONTRATADA não garante que as funções contidas no Software
                atendam às necessidades da CONTRATANTE, que a operação do Software
                será́ ininterrupta ou livre de erros, que qualquer funcionalidade
                continuará disponível, que os defeitos no Software serão corrigidos ou
                que o Software será́ compatível ou funcionará com qualquer software,
                aplicações ou serviços de terceiros.
              </p>
              <p>
                5.3. A CONTRATADA não se responsabiliza por qualquer decisão
                contábil/financeira tomada pela contratante com base nas informações
                obtidas por meio da utilização do software. Será responsabilidade
                exclusiva da CONTRATANTE conferir qualquer informação disponibilizada
                pelo SISTEMA SIGAME.
              </p>
              <br>
              <p>
                <strong>Cláusula 6ª - VALORES E FORMAS DE PAGAMENTO</strong>
              </p>
              <p>
                6.1&nbsp;- O valor estabelecido para este contrato será pago
                mensal no dia informado na adesão de cada mês a partir da data da
                vigência do contrato, através de CARTÃO DE CRÉDITO. Os valores são
                determinados por PLANOS DE LICENCIAMENTO, de acordo com o volume de
                notas fiscais e recursos disponíveis.
              </p>
              <p>
                6.2 - Os pagamentos dos serviços contratados serão processados através
                da plataforma de pagamento GREENN, sendo necessário que a CONTRATANTE
                leia e aceite os termos de uso e serviços da plataforma GREENN através
                do endereço eletrônico:&nbsp;
                <a href="https://greenn.com.br/termos-de-uso-greenn/">
                  https://greenn.com.br/termos-de-uso-greenn/
                </a>
              </p>
              <p>
                6.3&nbsp;- Caso a CONTRATANTE ultrapasse o volume de notas fiscais
                estabelecida no plano de licenciamento contratado, o valor adicional
                será calculado de acordo com o valor unitário por nota fiscal
                adicional do plano de licenciamento contratado, e será cobrado na
                fatura do mês subsequente.
              </p>
              <p>
                6.4&nbsp;- O valor do plano de licenciamento será reajustado a cada período
                de um ano, contado a partir da data de sua vigência, pelo IGPM da FGV
                ou por outro índice oficial que venha a substituí-lo ou, na ausência
                de substituto, pela média simples dos principais índices econômicos
                que apuram a inflação anual acumulada.
              </p>
              <p>
                6.5&nbsp;- O não pagamento das importâncias devidas pela CONTRATANTE à
                CONTRATADA na data dos respectivos vencimentos, implicará no acréscimo
                ao valor devido: multa de 5% (cinco por cento) e juros de mora
                vigentes, calculada desde o vencimento da fatura até a data do seu
                efetivo pagamento.
              </p>
              <p>
                6.6 – A falta de pagamento das importâncias devidas nas datas
                determinadas, acarretará a suspensão do uso do SISTEMA SIGAME, após o
                transcurso de 10 (dez) dias, considerando o vencimento da fatura,
                assim permanecendo até que as pendências financeiras sejam totalmente
                regularizadas.
              </p>
              <p>
                6.7 – Caso a CONTRATANTE não resolva as pendências financeiras no
                prazo de 60 (sessenta) dias corridos, a CONTRATADA se reserva ao
                direito de apagar de forma definitiva e irrecuperável todas as
                informações da CONTRATANTE que estejam armazenadas no SISTEMA SIGAME,
                bem como realizar o protesto dos débitos e inclusão do CONTRATANTE nos
                órgãos de proteção ao crédito.
              </p>
              <br>
              <p>
                <strong>Cláusula 7ª – MUDANÇA DE PLANO DE LICENCIAMENTO</strong>
              </p>
              <p>
                7.1 – Upgrade: É permitida a realização de UPGRADE, entre os PLANOS DE
                LICENCIAMENTO disponibilizados pela CONTRATADA, a qualquer tempo e sem
                custos adicionais, bastando para tal que a CONTRATANTE esteja em dia
                com suas obrigações e faça o pagamento da diferença de valor entre o
                PLANO DE LICENCIAMENTO vigente e o PLANO DE LICENCIAMENTO desejado.
              </p>
              <p>
                7.2 – Downgrade: É permitida a realização de DOWNGRADE somente entre
                os PLANOS DE LICENCIAMENTO pagos disponibilizados pela CONTRATADA, a
                qualquer tempo e sem custos adicionais, bastando para tal que a
                CONTRATANTE esteja em dia com suas obrigações e faça a solicitação de
                dowgrande pelos canais de atendimento da CONTRATADA. A CONTRATADA não
                realiza devoluções de valores para dowgrandes realizados antes do
                final do ciclo vigente, exceto em situações previamente acordadas com
                a CONTRATADA.
              </p>
              <br>
              <p>
                <strong>Cláusula 8ª – DA GARANTIA DE SAFISTAÇÃO</strong>
              </p>
              <p>
                8.1 - Caso a CONTRATANTE não esteja satisfeita por qualquer motivo,
                dentro dos primeiros 30 dias da contratação, basta solicitar o
                cancelamento por meio de algum canal de comunicação oficial, que A
                CONTRATADA reembolsará o valor pago, bem como cancelará o presente
                CONTRATO. Na hipótese de renovação do Plano de Licenciamento, a
                CONTRATANTE declara ciente que não possui garantia de reembolso.
              </p>
              <br>
              <p>
                <strong>Cláusula 9ª – VIGÊNCIA</strong>
              </p>
              <p>
                9.1 - O presente CONTRATO entra em vigor na data de seu aceite pela
                CONTRATANTE e vigorará pelo prazo do Plano contratado. Este CONTRATO
                será automaticamente renovado por iguais períodos caso a CONTRATANTE
                não se manifeste expressamente em contrário, nos mesmos termos e
                condições. Este CONTRATO poderá ser rescindido conforme estabelecido
                abaixo neste instrumento.
              </p>
              <br>
              <p>
                <strong>Cláusula 10ª - RESCISÃO</strong>
              </p>
              <p>
                10.1&nbsp;- O presente contrato poderá ser rescindido pela CONTRATANTE a
                qualquer tempo, bastando para tanto realizar a solicitação de
                cancelamento através dos canais de atendimento da SIGAME, com
                antedência mínima de 15 (quinze) dias, devendo pagar o saldo devedor
                do plano de licenciamento contratado, se existente.
              </p>
              <p>
                10.2 - A CONTRATADA poderá rescindir este CONTRATO a qualquer tempo,
                desde que comunique a CONTRATANTE, com antecedência mínima de 15
                (quinze) dias, devendo neste caso restituir a CONTRATANTE o saldo
                devedor do plano de licenciamento contratado, se existente. Este prazo
                de antecedência mínima e a obrigação de restituição acima não se
                aplicarão nos casos de violação do presente instrumento.
              </p>
              <p>
                10.3 - Para os planos personalizados de licenciamento com pagamento antecipado, caso
                a CONTRANTE decida rescindir antes do término do prazo contratado, a
                CONTRATADA não restituirá a CONTRATANTE o saldo restante do plano de
                licenciamento contratado (exceto em campanhas promocionais que
                prevejam a devolução dos valores pagos). Este valor será retido pela
                LICENCIANTE para cobrir os custos operacionais.
              </p>
              <br>
              <p>
                <strong>Cláusula 11ª – DA CONFIDENCIALIDADE DOS DADOS </strong>
              </p>
              <p>
                11.1 - Todas as informações pessoais relativas à LICENCIADA serão
                tratadas em concordância com a Lei nº 67/1998 e com a Lei nº
                13.709/2018, que dispõe sobre a Proteção de Dados Pessoais (LGPD).
              </p>
              <p>
                11.2 - O uso do certificado digital e-CNPJ A1 da CONTRATANTE,
                disponibilizado para CONTRATADA, será utilizado única e exclusivamente para
                assinatura digital das notas fiscais a serem emitidas pelo SOFTWARE.
              </p>
              <br>
              <p>
                <strong>Cláusula 12ª - DISPOSIÇÕES GERAIS</strong>
              </p>
              <p>
                12.1&nbsp;– O CONTRATANTE ao Aceitar o TERMO DE ADESÃO declara:
                <br>
                a)&nbsp;Conhecer o inteiro teor deste contrato de prestação de serviços e
                concordar com suas responsabilidades e direitos; <br>
                b)&nbsp;Estar ciente da obrigatoriedade de manter seus dados cadastrais
                atualizados, e em caso de alteração, notificar imediatamente o
                CONTRATADO.
              </p>
              <br>
              <p>
                <strong>Cláusula 13ª - FORO</strong>
              </p>
              <p>
                13.1 - Sendo esta a licença e o acordo completo entre ambas as partes,
                substituindo qualquer outro acordo ou discussão, oral ou por escrito,
                não podendo ser alterado a não ser por um acordo escrito, de ambas as
                partes, esta licença será regida e interpretada de acordo com as leis
                brasileiras para produtos comprados no Brasil.
              </p>
              <ul>
                <li>
                  <strong> Primeiro</strong>– Se qualquer cláusula deste Termo de Uso
                  for declarada inválida, ilegal ou inexequível por um Tribunal
                  competente, tal cláusula deve ser retirada, permanecendo vigentes as
                  demais.
                </li>
                <li>
                  <strong> Segundo</strong>– As partes elegem como foro do contrato a
                  cidade de Umuarama-PR, com exclusão de qualquer outro, por mais
                  privilegiados que sejam, sem, contudo, desmerecê-los, para dirimir
                  qualquer controvérsia proveniente deste instrumento.
                </li>
              </ul>
              <br>
              <p>Umuarama-PR, Julho de 2023.</p>
            </div>

            <div>
              <a class="getstarted align-items-center justify-content-center" href="/">Voltar</a>
            </div>

          </div>

        </div>

      </div>
  </section>

</template>

<script>
export default {
  name: 'TermoUsoComp'
}
</script>

<style scoped lang="scss">
.termo-uso {
  padding-top: 0;
  background-color: #f7f8fa;
  padding: 9vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.termo-uso .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.termo-uso.content {
  padding: 0;
}

.termo-uso.content h3 {
  font-weight: 700;
  font-size: 34px;
  color: $color-base;
}

.termo-uso.content p {
  margin-bottom: 0;
}
</style>
